/**
 * 비밀번호 최소 길이 — 서버 정책(`apps/server/src/auth/password.ts` 의 `PASSWORD_MIN`)과 같은 값.
 *
 * 입력 칸의 `minLength` 가 이 값을 쓴다. 따로 숫자를 적어 두었더니 서버가 8자로 바뀐 뒤에도
 * 칸은 10자를 고집해, 8~9자 비밀번호를 브라우저가 서버에 보내기도 전에 막았다(2026-10-02).
 * 어긋나면 `password.test.ts` 가 잡는다.
 */
export const PASSWORD_MIN = 8;
